import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { fadeUp, scrollToId } from "@/lib/motion";

export default function Services({ services = [] }) {
  return (
    <section id="services" data-testid="services-section" className="relative bg-slate-50 py-24 sm:py-32 border-t border-slate-200">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.div {...fadeUp} className="max-w-3xl">
          <span className="eyebrow">What we build</span>
          <h2 className="mt-4 font-display font-bold text-navy tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-[1.05]">
            Everything your business needs, <span className="text-gradient-blue">in one place.</span>
          </h2>
          <p className="mt-5 text-lg text-slate-600 leading-relaxed">
            We design, build and look after all of it, from the systems that run your operations to the content your customers see.
          </p>
        </motion.div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {services.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Boxes;
            return (
              <motion.button
                key={s.id}
                data-testid={`service-card-${s.id}`}
                onClick={() => scrollToId("quote")}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: (i % 3) * 0.06, ease: [0.22, 1, 0.36, 1] }}
                className="group text-left relative rounded-2xl border border-slate-200 bg-white p-6 transition-all duration-300 card-glow hover:-translate-y-1"
              >
                <div className="flex items-center justify-between">
                  <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-navy text-brand-cyan group-hover:bg-brand-blue group-hover:text-white transition-colors">
                    <Icon size={20} />
                  </span>
                  <span className="font-mono text-[0.62rem] uppercase tracking-[0.15em] text-slate-400">{s.category}</span>
                </div>
                <h3 className="mt-5 font-display text-lg font-semibold text-navy tracking-tight">{s.title}</h3>
                <p className="mt-2 text-sm text-slate-500 leading-relaxed">{s.desc}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-brand-blue opacity-0 group-hover:opacity-100 transition-opacity">
                  Discuss this <Icons.ArrowUpRight size={15} />
                </span>
              </motion.button>
            );
          })}
        </div>
      </div>
    </section>
  );
}
